import VueRouter, { Route } from 'vue-router';
import type { IModalRoute } from '../services';
import { RouteName } from '../routes/routes.constants';

/**
 * Type guard to check if the route provided has modal metadata
 * @param route the route to check
 */
export function isModalRoute(route: IModalRoute | Route): route is IModalRoute {
    return route.meta && route.meta.modal;
}

/**
 * Gets the defined modals on the route passed
 * through as an array of routes.
 * @param route The route to pull the modals from
 * @param router The main vue router instance
 */
export function getModals(
    query: Route['query'],
    router: VueRouter,
): IModalRoute[] {
    const modals = query.modal;

    if (!modals) {
        return [];
    }

    const modalPaths = Array.isArray(modals) ? modals : [modals];

    return modalPaths.map((path) => (router as any).match(path));
}

export function isModalOpen(
    name: RouteName,
    query: Route['query'],
    router: VueRouter,
): boolean {
    const modals = getModals(query, router);
    return modals.some((route) => route.name === name);
}
